import { render } from "./HealthCheck.vue?vue&type=template&id=310daac3"
import script from "./HealthCheck.vue?vue&type=script&lang=js"
export * from "./HealthCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__